import React from 'react';
import { connect, useDispatch } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Box, Button, PagePanel } from 'edenred-ui';
import { useTranslation } from 'react-i18next';

import { goToPage } from '@epi-actions/navigation';
import { routerPaths } from '@epi-constants/routerPaths';

import * as loginActions from '../../actions/login';

import './ResetPasswordRequested.scss';

function ResetPasswordRequested() {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  return (
    <div className="ResetPasswordRequested">
      <Box px={10}>
        <PagePanel>
          <Box textAlign="center">
            <h2 className="small">
              {t('containers.reset_password_requested.page_body')}
            </h2>
          </Box>
          <Box
            display="flex"
            alignContent="center"
            justifyContent="center"
            mt={3}
            pb={3}
          >
            <Button
              id="go-to-login-page-btn"
              onClick={() => {
                dispatch(goToPage(routerPaths.login));
              }}
            >
              {t('containers.reset_password_requested.login_button')}
            </Button>
          </Box>
        </PagePanel>
      </Box>
    </div>
  );
}

const mapDispatchToProps = dispatch =>
  bindActionCreators({ ...loginActions }, dispatch);

const ConnectedResetPasswordRequested = connect(
  null,
  mapDispatchToProps
)(ResetPasswordRequested);

export { ConnectedResetPasswordRequested as ResetPasswordRequested };
